import { type UseCase } from './BotUseCaseStep'

export const UseCaseCard = ({ useCase }: { useCase: UseCase }) => {
  return (
    <div className="flex w-full flex-col gap-3 px-3 py-6 text-center lg:px-8 lg:py-6">
      <useCase.icon className="h-6 w-6 self-center" />
      <h2 className="text-lg font-medium">{useCase.title}</h2>
      <p className="text-sm text-muted-foreground">{useCase.description}</p>
    </div>
  )
}
